import React from 'react'
import { useRouter } from 'next/router'
import Buoy from './Buoy'

const displayBuoyPaths = [
  '/',
  '/explore/[clas]',
  '/[website]',
  '/[website]/[postID]',
  '/forum/[forum]/[postID]',
]

export default function BuoyContainer(props) {
  const { pathname } = useRouter()
  if (props.isApp) return null
  if (displayBuoyPaths.includes(pathname)) return <Buoy {...props} />
  return null
}
